module.exports = __webpack_public_path__ + "static/media/image_11.64d265d9.png";